export function hideElementById(idElementInput?: string, isButtonClick?: boolean) {
  if (idElementInput?.trim()?.length > 0) {
    const element = document.getElementById(idElementInput);

    if (element) {
      // hide element by set style
      if (isButtonClick === undefined || !isButtonClick) {
        element.style.display = 'none';
        // hide element by click button
      } else if (isButtonClick !== undefined && isButtonClick === true) {
        element.click();
      }
    }
  }
}
